import React, { Component } from 'react';
import Notification from './Notification/Notification';

import './NotificationContainer.css';
import { getExpiryDate, hasDateExpired } from './Helpers/date';


class NotificationContainer extends Component {
    constructor(props) {
        super(props);
        this.dateTimeoutms = 5000;
        this.tickTimems = 200;
        this.state = {
            notifications: []
        }

    }

    closeNotification = (index) => {
        this.stopInterval();
        this.setState((prevState) => ({
            notifications: prevState.notifications.filter((_item, arrayIndex) => arrayIndex !== index)
        }));
    }
    notificationObjIsInvalid = (notificationObj) => (
        !notificationObj || !notificationObj.type || !notificationObj.message
    )

    findNotificationInBuffer = (notificationObj) => this.state.notifications.findIndex(item => (item.type === notificationObj.type && item.message === notificationObj.message))

    pushNotification = (notificationObj) => {
        if (this.notificationObjIsInvalid(notificationObj)) {
            console.warn("notificationObj requires fields 'type' and 'message', both are strings");
            return;
        }
        this.stopInterval();
        const indexInArray = this.findNotificationInBuffer(notificationObj);
        if (indexInArray < 0) {
            this.pushNew(notificationObj);
        } else {
            this.refreshNotification(indexInArray);
        }
        
            
        this.startInterval();
    }

    refreshNotification = (indexInArray) => {
        this.setState((prevState) => {
            const newNotifications = [...prevState.notifications];
            const notificationObj = newNotifications[indexInArray];
            notificationObj.expireTime = getExpiryDate(this.dateTimeoutms);
            return { notifications: newNotifications };
        });
    }

    pushNew = (notificationObj) => {
        this.setState((prevState) => {
            const newNotifications = [...prevState.notifications];
            newNotifications.push(notificationObj);
            notificationObj.expireTime = getExpiryDate(this.dateTimeoutms);
            return { notifications: newNotifications };
        });
    }

    tick = () => {
        if (this.state.notifications.length <= 0) { return; }
        this.setState((prevState) => {
            const date = new Date();
            const newNotifications = prevState.notifications.filter(item => (!hasDateExpired(date, item.expireTime)));
            return { notifications: newNotifications };
        });
    }

    startInterval = () => {
        this.interval = setInterval(this.tick, this.tickTimems);
    }

    stopInterval = () => {
        clearInterval(this.interval);
    }

    componentDidMount = () => {
        this.startInterval()
    }
    componentWillUnmount = () => {
        this.stopInterval();
    }

    render = () => (
        <div className="notification-container">
            {
                this.state.notifications.map((notificationProps, index) => (
                    <Notification
                        key={index}
                        onClick={() => this.closeNotification(index)}
                        {...notificationProps}
                    />
                ))
            }
        </div>
    )
}

export default NotificationContainer